module.exports = __webpack_public_path__ + "img/右下.bfbb8d74.png";